import { FaTwitter, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="py-[20px] bg-bg-alt border-t border-[rgba(255,255,255,0.05)]">
      <div className="container grid grid-cols-1 md:grid-cols-3 gap-1 items-center justify-items-center md:justify-items-stretch px-2 lg:px-16">
        <div className="flex gap-5 mb-1">
          <a href="https://www.linkedin.com/in/harshal-rajput-94755a228/" target="_blank" rel="noopener noreferrer" className="text-title text-h5 transition-all duration-700 ease-custom hover:text-primary">
            <FaLinkedin />
          </a>
          <a href="https://twitter.com/Harshal__Rajput" target="_blank" rel="noopener noreferrer" className="text-title text-h5 transition-all duration-700 ease-custom hover:text-primary">
            <FaTwitter />
          </a>
        </div>

        <p className="text-tiny font-bold text-center text-cs">
          &copy; 2026 <span className="text-primary">Harshal</span>. All Rights Reserved
        </p>

        <p className="text-tiny font-bold text-center md:text-right text-cs">
          Developed by <span className="text-primary">Harshal Rajput</span>
        </p>


      </div>
    </footer>
  );
};

export default Footer;
